import { TypedDocumentNode, gql } from "@apollo/client";

interface ServiceData {
  serviceByType: ServiceByTypeInterface[];
}

export enum ServiceType {
  IS_POPULAR = "IS_POPULAR",
  IS_CERTIFICATION_PROGRAM = "IS_CERTIFICATION_PROGRAM",
  IS_SKILL_BASED_COURSES = "IS_SKILL_BASED_COURSES",
  IS_NEW_LAUNCHED = "IS_NEW_LAUNCHED",
}

export const SERVICE_TYPE_OPTIONS = [
  {
    label: "Popular Courses",
    value: ServiceType.IS_POPULAR,
  },
  {
    label: "Certification Programs",
    value: ServiceType.IS_CERTIFICATION_PROGRAM,
  },
  {
    label: "Skill-based Courses",
    value: ServiceType.IS_SKILL_BASED_COURSES,
  },
  // {
  //   label: "New Launched",
  //   value: ServiceType.IS_NEW_LAUNCHED,
  // },
] as const;

export const GET_SERVICE_BY_TYPE: TypedDocumentNode<ServiceData, ServiceType> = gql`
  query GetServiceByType($serviceType: ServiceType!, $countryCode: String) {
    serviceByType(serviceType: $serviceType, country_code: $countryCode) {
      name
      isPopular
      rating
      id
      isSkillBasedCourses
      isCertificationProgram
      serviceImage
      service_image
      serviceIcon
      numberOfLearners
      slug
      accreditation_url
      accreditation_logo
      accreditation_name
      serviceTrainingDays
      price
      currency
      serviceContents {
        name
        isHtmlDescription
      }
      serviceLevel
      serviceFlags
      isGenericPageOnly
    }
  }
`;
